// src/pdf/pdfEngine.js
import jsPDF from "jspdf";
import logoSimbolo from '../assets/Logo_SALVIR.png';
import logoLetras from '../assets/Logo_SALVIR_letras.png';

/**
 * Motor puro de PDF (NO sabe de NOM).
 * - A4 vertical (mm)
 * - Márgenes ~20mm
 * - Header institucional + header clínico en cada página
 * - Footer: "Hoja X"
 * - Control de saltos de página y Y dinámico
 *
 * El contenido NOM vive en expedienteSections.js y usa este engine.
 */

export function createPdfEngine({
  medico = {},
  paciente = {},
  logoDoctorBase64 = null,
  creadoEnTexto = "Creado en: Salvir",
  tipoDocumento = "expediente",
} = {}) {
  const doc = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });

  // ====== CONFIG ======
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const margin = 20; // ~2 cm
  const contentWidth = pageWidth - margin * 2;

  // alturas reservadas
  const headerInstitutionalHeight = 22; // bloque superior
  const headerClinicalHeight = 10;       // franja clínica
  const headerGapAfter = 7;              // aire después del header
  const footerHeight = 10;

  // tipografía base
  const fontFamily = "helvetica";
  const fontSizeBase = 10;
  const lineHeight = 5.2;

  // estado
  let currentY = 0;
  let pageNumber = 0;

  // ====== HELPERS ======
  function setFontNormal(size = fontSizeBase) {
    doc.setFont(fontFamily, "normal");
    doc.setFontSize(size);
  }

  function setFontBold(size = fontSizeBase) {
    doc.setFont(fontFamily, "bold");
    doc.setFontSize(size);
  }

  function safeText(v) {
    if (v === null || v === undefined) return "";
    return String(v);
  }

 

  function maxContentY() {
    return pageHeight - margin - footerHeight;
  }

  // ====== HEADER / FOOTER ======
  function drawHeader() {
    // Header 1 (institucional)
    setFontNormal(10);

    const leftX = margin;
    const rightX = pageWidth - margin;

    // Bloque médico (izquierda) compacto 2-3 líneas
    const medicoLines = [];
    // Construir nombre completo
    const nombreCompletoMedico = [
    medico?.nombre,
    medico?.apellido_paterno,
    medico?.apellido_materno
    ].filter(Boolean).join(" ");

    // Prefijo Dr. / Dra.
    const sexo = String(medico?.sexo || "").toLowerCase();

    let prefijo = "Dr."; // default

    if (sexo.startsWith("f")) {
      prefijo = "Dra.";
    }

    if (nombreCompletoMedico) {
    medicoLines.push(`${prefijo} ${nombreCompletoMedico}`.trim());
    }

    // ============================
// BLOQUE ACADÉMICO COMPACTO HEADER
// ============================
// Aplica igual para expediente y hoja diaria.
// Licenciatura y cédula profesional SIEMPRE salen con etiqueta.

if (tipoDocumento === "hojaDiaria") {
  medicoLines.push(`Nombre del establecimiento: ${safeText(medico?.perfil?.nombre_clinica)}`);
}

medicoLines.push(
  `Licenciatura: ${safeText(medico?.perfil?.titulo_universitario)} · Cédula profesional: ${safeText(medico?.perfil?.cedula_profesional)}`
);

// Especialidad y cédula: solo si existen.
if (medico?.especialidad && medico?.perfil?.cedula_especialidad) {
  medicoLines.push(
    `Especialidad: ${safeText(medico.especialidad)} · Cédula especialidad: ${safeText(medico.perfil.cedula_especialidad)}`
  );
}

// Subespecialidad y cédula: solo si existen.
if (medico?.perfil?.subespecialidad && medico?.perfil?.cedula_subespecialidad) {
  medicoLines.push(
    `Subespecialidad: ${safeText(medico.perfil.subespecialidad)} · Cédula subespecialidad: ${safeText(medico.perfil.cedula_subespecialidad)}`
  );
}

// Alta especialidad y cédula: solo si existen.
if (medico?.perfil?.alta_especialidad && medico?.perfil?.cedula_alta_especialidad) {
  medicoLines.push(
    `Alta especialidad: ${safeText(medico.perfil.alta_especialidad)} · Cédula alta especialidad: ${safeText(medico.perfil.cedula_alta_especialidad)}`
  );
}

    // parte izquierda del header
    const medicoLinesMax = medicoLines;
    let y = 18;

    let textStartX = leftX;

    // ============================
    // SI HAY LOGO DEL DOCTOR
    // ============================
    if (logoDoctorBase64) {
      try {
        const logoHeight = 18; // 3 renglones aprox
        let format = "PNG";

        if (
          logoDoctorBase64.startsWith("data:image/jpeg") ||
          logoDoctorBase64.startsWith("data:image/jpg")
        ) {
          format = "JPEG";
        }

        // jsPDF puede obtener dimensiones reales automáticamente
        const imgProps = doc.getImageProperties(logoDoctorBase64);
        const aspectRatio = imgProps.width / imgProps.height;
        const logoWidth = logoHeight * aspectRatio;

        doc.addImage(
          logoDoctorBase64,
          format,
          leftX,
          y - 6,
          logoWidth,
          logoHeight
        );

        textStartX = leftX + logoWidth + 5;

      } catch (e) {
        textStartX = leftX;
      }
    }

    // ============================
    // TEXTO MÉDICO
    // ============================
    medicoLinesMax.forEach((line) => {
      doc.text(safeText(line), textStartX, y);
      y += 6;
    });

    

    // Bloque Salvir (derecha): logo + "Creado en Salvir"
   // Discreto, visible, no invasivo.
   //desactivado
   //
   // const logoTopY = 10;

    //try {
    //const simboloW = 9;
    //const simboloH = 9;

    //const letrasW = 28.5;
    //const letrasH = 12.3;

    // símbolo
    //doc.addImage(logoSimbolo, "PNG", rightX - letrasW - simboloW + 7, logoTopY+2, simboloW, simboloH);

    // letras
    //doc.addImage(logoLetras, "PNG", rightX - letrasW + 3 , logoTopY - 1, letrasW, letrasH);

    //setFontNormal(8);
    //doc.text(creadoEnTexto, rightX - simboloW + 7 , logoTopY + letrasH + 2  , { align: "right" });

    //} catch {
    // fallback texto
    //setFontBold(10);
    //doc.text("Salvir", rightX, 12, { align: "right" });
    //setFontNormal(8);
    //doc.text(creadoEnTexto, rightX, 16, { align: "right" });
    //}

    // Línea divisoria fina
    const lineY = y-2;
    doc.setLineWidth(0.4);
    doc.line(margin, lineY, pageWidth - margin, lineY);
    // Header 2 debajo de la línea
const headerY = lineY + 5;

if (tipoDocumento === "hojaDiaria") {
  currentY = headerY + headerGapAfter;
}  else {
  setFontBold(10);

    const pacienteNombre = `Paciente: ${paciente?.nombre_completo || paciente?.nombre || ""}`;

  // 1️⃣ Nombre paciente (principal)
  setFontBold(12);
  doc.text(pacienteNombre, leftX, headerY);

  // 2️⃣ Línea de datos fijos (más pequeña)
  setFontNormal(9);

  const rawId = paciente?.id || paciente?.id_expediente || "";
  const ID5 = rawId ? String(rawId).slice(-5).toUpperCase() : "";

  const edad = paciente?.edad ? `Edad: ${paciente.edad}` : "";
  const sexoPaciente = paciente?.sexo ? `Sexo: ${paciente.sexo}` : "";
  const fechaNacimiento = paciente?.fecha_nacimiento ? `Nac: ${paciente.fecha_nacimiento}` : "";
  const idExpediente = ID5 ? `ID Expediente: ${ID5}` : "";

  const lineaDatos = [
    edad,
    sexoPaciente,
    fechaNacimiento,
    idExpediente
  ].filter(Boolean).join(" · ");

  doc.text(lineaDatos, leftX, headerY + lineHeight);

  // Ajustar inicio de contenido dinámico
  currentY = headerY + lineHeight + headerGapAfter + lineHeight;
}
      }

  function drawFooter() {
    setFontNormal(9);
    const footerY = pageHeight - 6;

  // ===== Firma izquierda =====
    setFontNormal(9);

    // Línea de firma
    doc.text("_______________", margin, footerY - 4);

    // Texto "Firma" debajo
    doc.text("           Firma", margin, footerY);

    // ===== Número de página derecha =====
    doc.text(`Pag. ${pageNumber}`, pageWidth - margin, footerY, { align: "right" });

    }

  // ====== PÁGINAS ======
  function startNewPage() {
    // cerrar footer de página anterior
    if (pageNumber > 0) {
      drawFooter();
      doc.addPage();
    }
    pageNumber += 1;
    drawHeader();
  }

  function ensureSpace(requiredHeight = lineHeight) {
    if (currentY + requiredHeight > maxContentY()) {
      startNewPage();
    }
  }

  // ====== TEXTO / BLOQUES ======
  function addVerticalSpace(mm = 3) {
    currentY += mm;
  }

  function writeCenteredTitle(text) {
    ensureSpace(lineHeight * 2);
    setFontBold(12);
    doc.text(safeText(text), pageWidth / 2, currentY, { align: "center" });
    currentY += lineHeight + 2;
    setFontNormal(fontSizeBase);
  }

  function writeTitle(text) {
    ensureSpace(lineHeight * 2);
    setFontBold(11);
    doc.text(safeText(text), margin, currentY);
    currentY += lineHeight + 1;
    setFontNormal(fontSizeBase);
  }

  function writeSubtitle(text) {
    ensureSpace(lineHeight * 2);
    setFontBold(10);
    doc.text(safeText(text), margin, currentY);
    currentY += lineHeight;
    setFontNormal(fontSizeBase);
  }

  function writeParagraph(text = "") {
    const t = safeText(text);

    // Si viene vacío, imprimimos línea en blanco (pero el caller decide si imprime rubro)
    if (!t) {
      ensureSpace(lineHeight);
      currentY += lineHeight;
      return;
    }

    setFontNormal(fontSizeBase);
    const lines = doc.splitTextToSize(t, contentWidth);

    lines.forEach((line) => {
      ensureSpace(lineHeight);
      doc.text(line, margin, currentY);
      currentY += lineHeight;
    });

    currentY += 1.5; // aire
  }

  function writeLabelValue(label, value = "") {
    const lbl = safeText(label);
    const val = safeText(value);

    if (val) {
      writeParagraph(`${lbl}: ${val}`);
    } else {
      // IMPORTANT: Solo imprime el label con ":" si no hay valor
      // (Cumple con tu regla: rubro visible, sin inventar texto)
      writeParagraph(`${lbl}:`);
    }
  }

  // Firma protegida (no cortar)
  function drawSignatureBlock(nombreMedico = "") {
    const blockHeight = 18;
    ensureSpace(blockHeight);

    const lineY = currentY + 8;
    doc.setLineWidth(0.2);
    doc.line(margin, lineY, margin + 70, lineY);

    setFontNormal(10);
    doc.text(safeText(nombreMedico), margin, lineY + 6);

    currentY = lineY + 10;
  }

  // Tabla simple (para anexo signos vitales, sin plugins)
  function drawSimpleTable({ columns = [], rows = [], colWidths = [] }) {
    // estimación mínima de altura por fila
    const rowH = 7;

    // header
    ensureSpace(rowH + 2);
    setFontBold(9);

    let x = margin;
    const widths =
      colWidths.length === columns.length
        ? colWidths
        : columns.map(() => contentWidth / columns.length);

    // Dibujar header row
    columns.forEach((c, i) => {
      doc.text(safeText(c), x, currentY);
      x += widths[i];
    });
    currentY += rowH - 2;

    setFontNormal(9);
    doc.setLineWidth(0.2);
    doc.line(margin, currentY, pageWidth - margin, currentY);
    currentY += 4;

    // rows
    rows.forEach((r) => {
      ensureSpace(rowH);
      let xx = margin;

      r.forEach((cell, i) => {
        const cellText = safeText(cell);
        // recorte simple: si es muy largo, se parte en 1-2 líneas
        const cellLines = doc.splitTextToSize(cellText, widths[i] - 1);
        doc.text(cellLines.slice(0, 2), xx, currentY);
        xx += widths[i];
      });

      currentY += rowH;
    });

    currentY += 2;
  }

  // ====== EXPORT ======
  function save(filename = "expediente_clinico.pdf") {
    drawFooter(); // última página
    doc.save(filename);
  }

  function output(type = "blob") {
    drawFooter();
    return doc.output(type);
  }

  // Inicializar primera página
  startNewPage();

  return {
    // doc
    doc,

    // páginas
    startNewPage,
    ensureSpace,

    // texto / layout
    addVerticalSpace,
    writeCenteredTitle,
    writeTitle,
    writeSubtitle,
    writeParagraph,
    writeLabelValue,

    // bloques
    drawSignatureBlock,
    drawSimpleTable,

    // estado
    getCurrentY: () => currentY,
    getPageNumber: () => pageNumber,
    getPageSize: () => ({ pageWidth, pageHeight }),
    getLayout: () => ({
      margin,
      contentWidth,
      headerInstitutionalHeight,
      headerClinicalHeight,
      footerHeight,
      lineHeight,
    }),

    // export
    save,
    output,
  };
}
